// 1. New array added by "New class subject button" is called newArr
// newArr can be found in line 469
// api passed on 146,171,724,632,276
// table change 650
// change of label fields 432,458,519

import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import { BsSearch } from 'react-icons/bs'
import {optionsClass, optionsExam, optionsSubject, optionssection, roledrp } from '../../Helper'
import moment from 'moment'
import { stuassessmentApi } from '../../../utils/AdminDashApi/StuWiseAssessmentApi'



const SubWiseAssessmentComp = () => {
  const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
  const [activefrom2,setactivefrom2] = useState("")
  const [activeto2,setactiveTo2] = useState("")
  const [show,setShow] = useState(10)
  const [show2,setShow2] = useState("")

  const [exam,setexam] = useState("")
  const [myclass,setclass] = useState("")
  const [section,setsection] = useState("")
  const [subject,setsubject] = useState("")
  
  const [borderexam,setborderexam] = useState("")
  const [borderclass,setborderclass] = useState("")
  const [bordersection,setbordersection] = useState("")
  const [bordersubject,setbordersubject] = useState("")

  const [labelexam,setlabelexam] = useState("")
  const [labelclass,setlabelclass] = useState("")
  const [labelsection,setlabelsection] = useState("")
  const [labelsubject,setlabelsubject] = useState("")

  const drpfuncexam=(myval,myid)=>{
    setexam(myid)
  }
  const drpfuncclass=(myval,myid)=>{
    setclass(myid)
  }
  const drpfuncsection=(myval,myid)=>{
    setsection(myid)
  }
  const drpfuncsubject=(myval,myid)=>{
    setsubject(myid)
  }

  const handleSearch=()=>{
    console.log(exam,
        myclass,
        section,
        subject)
  }
  const handlePrint=()=>{

  }
 
 
  const handleShow = () => setShow2(true);
 
  const [newArr,setNewArr] = useState([])
  const [classresponse, setclassresponse] = useState([]);
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
}
  useEffect(() => {
    const fetchClassDropdown = async () => {
        try {
            const classresponse = await axios.get(
                "https://sass.britishstandardschool.com/api/Public/ClassList",
                {},
                headers
            );
            setclassresponse(classresponse.data);
            // console.log(classresponse);
        } catch (err) {
            if (err.classresponse) {
                console.error(err.classresponse.data);
                console.log(err.classresponse.status);
                console.log(err.classresponse.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
    };
    fetchClassDropdown();
}, []);
  const optionsShowt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]
  const [mainpagesearch,setmainpagesearch] = useState([])
  const handlemainpagesearch=()=>{
      
    if(!exam && exam==""){
        setborderexam("err")
        setlabelexam("Exam required")
    }
    else{
        setborderexam("")
        setlabelexam("")
    }
    if(!myclass && myclass==""){
        setborderclass("err")
        setlabelclass("Class required")
    }
    else{
        setborderclass("")
        setlabelclass("")
    }
    if(!section && section==""){
        setbordersection("err")
        setlabelsection("Section required")
    }
    else{
        setbordersection("")
        setlabelsection("")
    }
    if(!subject && subject==""){
        setbordersubject("err")
        setlabelsubject("Subject required")
    }
    else{
        setbordersubject("")
        setlabelsubject("")
    }

    if(subject && exam && section && myclass){
        console.log("DONE")
    }



      console.log(exam,
          myclass,
          section,
          subject)
  }


  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(stuassessmentApi.data)


  const mainfilter=(searchkey,arr)=>{    
    
    return arr;
    
  }



  const [tempfilteredarr,settempfilteredarr] = useState([])
    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;        
        setCurrentItems(stuassessmentApi.data.slice(itemOffset, endOffset));        
        setPageCount(Math.ceil(stuassessmentApi.data.length / itemsPerPage));
        
      }, [itemOffset, itemsPerPage]);
      let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
      useEffect(()=>{
        const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
        settempfilteredarr(filteredArr.slice(itemOffsetfiltered, endOffsetfiltered));
        setPageCountfiltered(Math.ceil(pagecountoffilter / itemsPerPagefiltered));
        setpagecountoffilter(filteredArr.length)
      },[itemOffsetfiltered,itemsPerPagefiltered])
    
      // Invoke when user click to request another page.
      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % stuassessmentApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    
      const handleClose=()=>{
        setShow2(false)
      }
      const [rolemodalvalue,setrolemodalvalue] = useState("")
      const [subjectnamemodalvalue,setsubjectnamemodalvalue] = useState("")
      const [classnamemodalvalue,setclassnamemodalvalue] = useState("")
      
      const [subjectnamemodalvalue2,setsubjectnamemodalvalue2] = useState("")
      const [classnamemodalvalue2,setclassnamemodalvalue2] = useState("")
      const [rolemodalvalue2,setrolemodalvalue2] = useState("")
     
      
    

    const [searchinputmodal,setsearchinputmodal] = useState("")
   
   

    useEffect(()=>{
      
        mainfilter(mainpagesearch,stuassessmentApi.data)      

      
    },[])
    
    
    

    // start
  return (
    <div className="d-flex flexvaluecomp">

       <SidebarOfAdash/>
       <div className="contentpartwidthwrapper">
          <HeaderofAdash head="Subject Wise Assessment Mark"/>
          <div className="contentofadmindash contentflexvalue">
          <div className="m-auto w690">
                    <Row>
                        <Col lg={4} className="pr7">
                              <div className="basicinputfield h35p">
                                  <p>Exam</p>
                                  <div className="inputgap h35">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={borderexam} func={drpfuncexam} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsExam} />
                                      </div>
                                      <label>{labelexam}</label>
                                  </div>
                              </div>
                        </Col>
                        <Col lg={4} className="pr7 pl7">
                              <div className="basicinputfield h35p">
                                  <p>Class</p>
                                  <div className="inputgap h35">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={borderclass} func={drpfuncclass} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsClass} />
                                      </div>
                                      <label>{labelclass}</label>
                                  </div>
                              </div>
                        </Col>
                        <Col lg={4} className="pr7 pl7">
                              <div className="basicinputfield h35p">
                                  <p>Section</p>
                                  <div className="inputgap h35">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={bordersection} func={drpfuncsection} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssection} />
                                      </div>
                                      <label>{labelsection}</label>
                                  </div>
                              </div>
                        </Col>

                    </Row>

                </div>
            
              <div className="w560 m-auto">
                    <Row>
                        <Col lg={8}>
                        <div className="basicinputfield h35p">
                                  <p>Subject</p>
                                  <div className="inputgap h35">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={bordersubject} func={drpfuncsubject} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsSubject} />
                                      </div>
                                      <label>{labelsubject}</label>
                                  </div>
                              </div>
                        </Col>
                        <Col lg={1}>
                        <div className="basicinput">
                            <p></p>
                            <button className='cmbutton onlysearch' onClick={handlemainpagesearch}> <BsSearch /></button>
                        </div>
                        
                        </Col>
                        <Col lg={3}>
                            <div className="basicinput">

                        <p></p>
                            <button className='cmbutton' onClick={handlePrint}>Print</button>
                            </div>
                        </Col>
                    </Row>

              
              </div>

              <Row>
                <Col lg={12} className="m-auto">
                  <div className="flexvaluetable">
                    <table>
                      <thead>
                        <tr>
                            {
                              stuassessmentApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            filteredArr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {stuassessmentApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>

              
              </div>
              </div>
              </div>
  )
}

export default SubWiseAssessmentComp